/*@ngInject*/
const ReportActionsMediator = function (reportActionRepository) {

    this.generateReport = function(reportId) {
        return reportActionRepository.generateReport(reportId);
    };

    this.createReport = function(submissionId, reportName) {
        return reportActionRepository.createReport(submissionId, reportName);
    };

    this.editReport = function(reportId) {
        return reportActionRepository.editReport(reportId);
    };

    this.deleteReport = function(reportId) {
        return reportActionRepository.deleteReport(reportId);
    };

};

angular.module('gw-um-submission').service('reportActionsMediator', ReportActionsMediator);
